import { render, staticRenderFns } from "./HandbookIndex.vue?vue&type=template&id=76389667"
import script from "./HandbookIndex.vue?vue&type=script&lang=js"
export * from "./HandbookIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports